import { Plugins } from '@leverege/plugin';
function addToType(typeMap, type, coordinate) {
  const arr = typeMap.get(type);
  if (arr == null) {
    typeMap.set(type, [coordinate]);
  } else {
    arr.push(coordinate);
  }
}
function addNamed(nameMap, name, coordinate) {
  const arr = nameMap.get(name);
  if (arr == null) {
    nameMap.set(name, [coordinate]);
  } else {
    arr.push(coordinate);
  }
}
function addToLookup(lookup, name, objectType, coordinate) {
  const key = nameTypeKey(name, objectType);
  const tCoord = lookup.get(key);
  if (tCoord == null) {
    lookup.set(key, [coordinate]);
  } else {
    tCoord.push(coordinate);
  }
}
function nameTypeKey(name, objectType) {
  return `${name}:${objectType}`;
}
function addCoordinate({
  types,
  named,
  lookup
}, coordinates) {
  for (let n = 0; n < coordinates.length; n++) {
    const coordinate = coordinates[n];
    const {
      objectType,
      attrName
    } = coordinate;
    if (Array.isArray(objectType)) {
      objectType.forEach(type => {
        addToType(types, type, coordinate);
      });
    } else {
      addToType(types, objectType, coordinate);
    }
    addNamed(named, attrName, coordinate);
    addToLookup(lookup, attrName, objectType, coordinate);
  }
}
function processor(coordinates) {
  const types = new Map(); // name:type -> attribute lookup
  const named = new Map(); // name -> attribute lookup
  const lookup = new Map();
  addCoordinate({
    types,
    named,
    lookup
  }, coordinates);

  // Add any columns available from a a creator
  const creators = Plugins.get('CoordinateCreator');
  creators.forEach(creator => {
    const coordinates = creator.create();
    addCoordinate({
      types,
      named,
      lookup
    }, coordinates);
  });
  return {
    types,
    named,
    lookup
  };
}
const view = Plugins.createView('Coordinate', {
  processor
});
const dirty = () => {
  view.dirty = true;
};
Plugins.get('CoordinateCreator').forEach(dc => {
  dc.onChange(dirty);
});
Plugins.on('CoordinateCreator', evt => {
  const add = evt.type === Plugins.PLUGIN_ADDED;
  evt.plugin.onChange(add ? dirty : null);
});
export default {
  getCoordinatesFor(type) {
    if (Array.isArray(type)) {
      const coordinateLookup = {};
      type.forEach(t => {
        const {
          types
        } = view.get();
        const coordinates = types.get(t) || [];
        coordinates.forEach(coordinate => {
          const c = coordinate.create();
          coordinateLookup[c.attrName] = coordinate;
        });
      });
      return Object.values(coordinateLookup);
    }
    const {
      types
    } = view.get();
    return types.get(type) || [];
  },
  getCoordinates(name) {
    const {
      named
    } = view.get();
    const coords = named.get(name);
    if (coords) {
      return coords;
    }
    return [];
  },
  getCoordinate(name, objectType) {
    const {
      lookup
    } = view.get();
    const coords = lookup.get(nameTypeKey(name, objectType));
    if (coords) {
      return coords[0];
    }
    return null;
  }
};